import {connect} from 'react-redux';
import ContentPartnersContainer from './ContentPartnersContainer';
import {setContentPartnersAction} from './Redux/ContentPartnersAction';
import {ContentPartnerState} from './ContentPartnersTypes';

export interface ContentPartnersState {
    contentPartnersManager: ContentPartnerState;
}

export const mapState = ({contentPartnersManager}: ContentPartnersState) => {
    const {rows, total} = contentPartnersManager;
    return {
        contentPartners: rows,
        total,
    };
};

export const mapDispatch = {
    setContentPartners: setContentPartnersAction,
};

export default connect(mapState, mapDispatch)(ContentPartnersContainer);
